module.exports = __webpack_public_path__ + "img/lingbolive_name@3xnew.b00f4aab.png";